import React, {Component} from 'react'

class PriceListingRow extends Component {

    static propTypes = {};

    render() {

        let hints = [];

        if (this.props.hint) {
            hints.push(this.props.hint);
        }

        if (this.props.monthly) {
            hints.push("mtl.");
        }

        if (this.props.tax) {
            hints.push("zzgl. USt.*");
        }

        return (
            <div className={"price-listing-row" + (this.props.className ? " " + this.props.className : "") + (this.props.promotion ? " price-listing-row--promotion" : "")}>
                <div className={"price-listing-row__content"}>
                    <div title={this.props.title}>{this.props.title}</div>
                    <div>{this.props.caption}</div>
                </div>
                <div className={"price-listing-row__price"}>
                    <div>{this.props.prefix ? <span>{this.props.prefix}</span> : null} {this.props.price}</div>
                    <div>{hints.join(", ")}</div>
                </div>
            </div>
        );
    }

}

export default PriceListingRow



/** WEBPACK FOOTER **
 ** ./src/components/PriceListingRow.js
 **/